import { NationalityModel } from '@core/data-access';

export class NationalityEntity extends NationalityModel {}
